import { useCallback, useEffect, useState } from 'react'

const useScroll = () => {
  const [scrollDirection, setScrollDirection] = useState('up')
  const [currentScroll, setCurrentScroll] = useState(0)
  const [isScrolling, setIsScrolling] = useState(false)

  const onScroll = useCallback(() => {
    const scroll = window.scrollY
    setScrollDirection(scroll > currentScroll ? 'down' : 'up')
    setCurrentScroll(scroll)
  }, [currentScroll])

  useEffect(() => {
    setIsScrolling(true)
    const timeout = setTimeout(() => setIsScrolling(false), [50])
    return () => clearTimeout(timeout)
  }, [currentScroll])

  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [onScroll])

  return { scroll: currentScroll, direction: scrollDirection, isScrolling }
}

export default useScroll
